import { type UseQueryOptions, useMutation, useQueries } from 'react-query';

import { http } from '../base/http';
import type { Font } from '../types/font';

export const useCreateFontFile = (args: Record<string, unknown> = {}) => {
    return useMutation({
        mutationFn: (file: File) =>
            new Promise((resolve) => {
                (async () => {
                    const updates = new FormData();
                    updates.append('file', file);
                    http.upload(
                        '/font_files',
                        'POST',
                        updates,
                        () => {}, // Progress callback if needed
                        (response: ProgressEvent) => resolve(response),
                    );
                })();
            }),
        ...args,
    });
};

export interface FontFileQueriesResult {
    url: string;
    font: Font;
    file: ArrayBuffer;
}

export const useFontFileQueries = (fonts: Font[], options?: UseQueryOptions<FontFileQueriesResult, Error>) => {
    const uniqueFonts = [...new Map(fonts.map((font) => [font.fontFile.file, font])).values()]; // Remove duplicates

    return useQueries(
        uniqueFonts.map((font) => {
            const url = font.fontFile.file;
            return {
                queryKey: ['font-urls', url],
                queryFn: () =>
                    http
                        .getFile(url, 'font/*')
                        .then((res) => res.arrayBuffer())
                        .then((file) => {
                            return { url, font, file };
                        }),
                staleTime: Number.POSITIVE_INFINITY,
                cacheTime: Number.POSITIVE_INFINITY,
                ...options,
            };
        }),
    );
};
